module.exports = __webpack_public_path__ + "static/halfling-monk-AYAGWW-8ca96f9b95254dded89d665d0901201c.png";